document.addEventListener('DOMContentLoaded', function () {
  const easyReadButton = document.querySelector('[data-easy-read-toggle]');

  function moveTitlesToContent() {
    document.querySelectorAll('.update-item').forEach((item) => {
      const title = item.querySelector('.update-item__top-text h3');
      const content = item.querySelector('.update-item__content');
      if (title && content) {
        content.insertBefore(title, content.firstChild);
      }
    });
  }

  // Check for cookie on page load
  if (document.cookie.includes('easy-read=true')) {
    document.documentElement.classList.add('easy-read');
    moveTitlesToContent();
  }

  if (easyReadButton) {
    easyReadButton.addEventListener('click', function () {
      document.documentElement.classList.toggle('easy-read');

      if (document.documentElement.classList.contains('easy-read')) {
        moveTitlesToContent();
        document.cookie = 'easy-read=true; path=/; max-age=31536000';
        window.dispatchEvent(new Event('easy-read-on'));
      } else {
        document.cookie = 'easy-read=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
        window.dispatchEvent(new Event('easy-read-off'));
      }
    });
  }
});
